(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxPrintixPrintApi(
    $http, toastr, $filter, $timeout
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=resource',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/softwareDistribution/printixPrintApi/printixPrintApi.template.html',
      link: function(scope) {

        scope.key = {
          name: '',
          accept: false
        };
        scope.hideUI_elements = false;
        scope.apiCredentials = null;
        scope.focus = false;



        $timeout(function () { 
          scope.focus = true;
        }, 100)

        scope.createKioskID = function () {
          var url = scope.tenant.info._links['px:createCloudPrintApiOauth'].href + '?clientName=' + scope.key.name;
          
          $timeout(function () {
            $http.post(url, scope.key.name).then(function(response) {
              toastr.success($filter('translate')('CloudPrintApiCredentialsCreated'))
              scope.hideUI_elements = true;
              scope.apiCredentials = response.data;
            }).catch(function(error){
              toastr.error($filter('translate')('ERROR'))
              scope.callback();
            });
          }, 1)
        }
        
        scope.copySecret = function (copy) {
          var input = document.createElement('input');
          var value = null;

          switch (copy) {
            case 'secret':
              value = scope.apiCredentials.secret;
            break;
            case 'clientId':
              value = scope.apiCredentials.clientId;
            break;
            case 'tenantId':
              value = scope.tenant.customProperties.id;
            break;
          }

          input.setAttribute('value',  value);
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          document.body.removeChild(input)
          toastr.success($filter("translate")("CopyToClipboard"));
        }

      }
    };
  }

  pxPrintixPrintApi.$inject = ['$http', 'toastr', '$filter', '$timeout'];

  angular
    .module('printix-admin')
    .directive('pxPrintixPrintApi', pxPrintixPrintApi);

})();
